import {HttpResponse} from '@angular/common/http';
import {Component, OnDestroy, OnInit} from '@angular/core';
import {PageEvent} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';
import {Title} from '@angular/platform-browser';
import {ActivatedRoute} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {JhiAlertService, JhiEventManager, JhiParseLinks} from 'ng-jhipster';
import {Subscription} from 'rxjs';
import {Principal} from '@core/index';

import {QrCodeService} from '@entities/qr-code/qr-code.service';
import {IProduct} from '@entities/san-pham/san-pham.model';
import {ITEMS_PER_PAGE, PAGE_SIZE_OPTIONS} from '@app/shared';
import {DialogService} from '@shared/confirm-dialog/dialog.service';
import {exportFileData} from '@shared/util/export-file';

@Component({
  selector: 'app-qr-code',
  templateUrl: './qr-code.component.html',
})
export class QrCodeComponent implements OnInit, OnDestroy {
  displayedColumns: string[] = [
    'id',
    'productName',
    'maLo',
    'soLuong',
    'ngayTao',
    'trangThai',
    'action',
  ];
  dataSource: any;
  pageSizeOptions: number[] = PAGE_SIZE_OPTIONS;
  ELEMENT_DATA: any[] = [];
  links: any;
  totalItems: any;
  queryCount: any;
  itemsPerPage = ITEMS_PER_PAGE;
  page = 1;
  currentSearch = '';
  eventSubscriber: Subscription;
  noData: boolean;
  isLoading = true;

  constructor(
    private titleService: Title,
    private translate: TranslateService,
    private alertService: JhiAlertService,
    private principal: Principal,
    private parseLinks: JhiParseLinks,
    private eventManager: JhiEventManager,
    private activatedRoute: ActivatedRoute,
    private qrcodeService: QrCodeService,
    private confirmService: DialogService,
  ) {
    this.dataSource = new MatTableDataSource([]);
  }

  ngOnInit() {
    this.titleService.setTitle(
      this.translate.instant(
        'entities.qr-code.qr-code.Danh sách tạo mã QR_title',
      ),
    );
    this.loadAll();
    this.eventSubscriber = this.eventManager.subscribe(
      'qrcodeListModification',
      () => this.loadAll(),
    );
  }

  ngOnDestroy() {
    if (this.eventSubscriber) {
      this.eventManager.destroy(this.eventSubscriber);
    }
  }
  search(query: string) {
    this.page = 1;
    this.currentSearch = query;
    this.loadAll();
  }
  loadAll() {
    this.isLoading = true;
    this.qrcodeService
      .query(
        {
          page: this.page - 1,
          size: this.itemsPerPage,
          sort: ['createdDate,desc'],
        },
        {
          productName: this.currentSearch,
        },
      )
      .subscribe(
        (res: HttpResponse<IProduct[]>) => {
          this.isLoading = false;
          this.totalItems = res.headers.get('X-Total-Count');
          this.queryCount = this.totalItems;
          this.ELEMENT_DATA = res.body;
          this.dataSource = new MatTableDataSource(this.ELEMENT_DATA);
          this.noData = res.body.length === 0;
        },
        (res: HttpResponse<any>) => {
          this.isLoading = false;
          this.alertService.error(res.body.error, res.body.message, null);
        },
      );
  }

  loadPage(event: PageEvent) {
    this.page = event.pageIndex + 1;
    this.itemsPerPage = event.pageSize;
    this.loadAll();
  }

  private onSuccess(data: any, headers: any, type: string) {
    this.isLoading = false;
    this.totalItems = headers.get('X-Total-Count');
    this.queryCount = this.totalItems;
    this.ELEMENT_DATA = data;
    this.dataSource = new MatTableDataSource(this.ELEMENT_DATA);
    this.noData = data.length === 0;
  }

  changeStatusCode(qrCode: any, status: string) {
    const titleKey =
      status === 'ACTIVE'
        ? 'entities.qr-code.qr-code.Kích hoạt mã QR_dialog_title'
        : 'entities.qr-code.qr-code.Hủy mã QR_dialog_title';
    const contentKey =
      status === 'ACTIVE'
        ? 'entities.qr-code.qr-code.Bạn muốn kích hoạt tất cả mã QR của lần tạo này?_dialog_content'
        : 'entities.qr-code.qr-code.Bạn muốn hủy tất cả mã QR của lần tạo này?_dialog_content';

    this.confirmService
      .confirm(
        this.translate.instant(titleKey),
        this.translate.instant(contentKey),
      )
      .subscribe((res) => {
        if (res) {
          this.qrcodeService
            .updateTBCode(qrCode.id, status)
            .subscribe((response) => {
              console.log(response);
            });
        }
      });
  }

  exportFile(item: any, isPdf: boolean): void {
    if (isPdf) {
      this.qrcodeService.exportPdfQuery(item.id).subscribe((res) => {
        exportFileData(res.body, res.headers);
      });
    } else {
      this.qrcodeService.exportQuery(item.code).subscribe((res) => {
        exportFileData(res.body, res.headers);
      });
    }
  }
}
